
import React from "react";

interface FlowStepProps {
  imageUrl: string;
  imageAlt: string;
  label: string;
  gradientFrom: string;
  gradientTo: string;
}

const FlowStep = ({ imageUrl, imageAlt, label, gradientFrom, gradientTo }: FlowStepProps) => {
  return (
    <div className="flex flex-col items-center flex-shrink-0 group">
      <div className="relative">
        {/* Glow effect */}
        <div className={`absolute inset-0 w-20 h-20 md:w-24 md:h-24 bg-gradient-to-br ${gradientFrom} ${gradientTo} rounded-full opacity-20 blur-xl group-hover:opacity-30 transition-opacity duration-300`}></div>
        {/* Main circle */}
        <div className={`relative w-20 h-20 md:w-24 md:h-24 bg-gradient-to-br ${gradientFrom} via-${gradientFrom.split('-')[1]}-${gradientFrom.split('-')[2]} ${gradientTo} rounded-full flex items-center justify-center shadow-2xl mb-3 border-2 border-white/20 group-hover:scale-105 transition-all duration-300 overflow-hidden`}>
          <div className="absolute inset-2 bg-gradient-to-br from-white/10 to-transparent rounded-full"></div>
          <img 
            src={imageUrl} 
            alt={imageAlt} 
            className="relative w-full h-full object-cover rounded-full drop-shadow-sm"
          />
        </div>
      </div>
      <span className="text-sm md:text-base font-semibold text-gray-700 text-center px-2 py-1 bg-white/50 rounded-lg backdrop-blur-sm border border-gray-200/50">{label}</span>
    </div>
  );
};

export default FlowStep;
